import { type UseQueryResult, useQuery } from 'react-query';
import { OptionAwardService } from '../../services/wealthlane-award-services';
import { FeatureSetService } from '../../services/wealthlane-identity-services';

const useGetFeatureSetOption = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const featureSetOption = useQuery(
    ['getFeatureSetOption'],
    async () => {
      return await handleRequest(FeatureSetService.getApiIdentityFeatureSetOptions());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return featureSetOption;
};

export default useGetFeatureSetOption;
